import { Wrench, Zap, Wind, Trees, Sparkles, Home, LayoutGrid } from "lucide-react";

const CAT_META: Record<string, { img: string; icon: any; blurb: string }> = {
  "cat-plumbing": { img: "/img/plumbing.jpg", icon: Wrench, blurb: "Leaks, water heaters, drains" },
  "cat-electrical": { img: "/img/electrical.jpg", icon: Zap, blurb: "Lighting, panels, wiring" },
  "cat-hvac": { img: "/img/hvac.jpg", icon: Wind, blurb: "Heating, cooling, air quality" },
  "cat-landscaping": { img: "/img/landscaping.jpg", icon: Trees, blurb: "Lawns, planting, outdoor care" },
  "cat-cleaning": { img: "/img/cleaning.jpg", icon: Sparkles, blurb: "Home and office cleaning" },
  "cat-roofing": { img: "/img/roofing.jpg", icon: Home, blurb: "Repairs, inspections, replacements" },
};

export const catMeta = (id?: string) => CAT_META[id || ""] || { img: "/img/hero.jpg", icon: LayoutGrid, blurb: "Approved local providers" };
